import Axios from "axios";

const INITIAL_STATE = {
  team: {
    total: 0,
    perPage: 0,
    page: 0,
    lastPage: 0,
    data: [
      {
        id: null,
        name: null,
        occupation: null,
        email: null,
        department: null,
        image_path: null,
        is_active: null,
      },
    ],
  },
};

export const updateTeam = param => ({
  type: "SET_TEAM",
  payload: param,
});

export const getTeam = (url, config) => (dispatch, getState) => {
  return Axios.get(url, config)
    .then(resp => {
      dispatch(updateTeam(resp.data));
    })
    .catch(function (error) {});
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_TEAM":
      return { ...state, team: action.payload };
    default:
      return state;
  }
};
